var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "bb-1 p-3" }, [_vm._t("title")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "p-3" }, [_vm._t("content")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }